import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const RealEstate: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.8028 50.6853V23.6214L28.3325 11.6475L48.8497 23.6214V50.6853H7.8028Z"
        stroke={props.htmlColor || 'black'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46777 20.8943L28.3331 7.55811L39.7588 14.2262L51.1844 20.8943"
        stroke={props.htmlColor || 'black'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="22.7769"
        y="27.9751"
        width="11.0987"
        height="11.0987"
        fill={props.htmlColor || '#FFCB06'}
        stroke={props.htmlColor || '#FFCB06'}
      />
    </SvgIcon>
  );
};

export default RealEstate;
